import { PapiDeviation } from '@wix/da-papi-types';
import MediaService from '@wix/da-shared-react/pkg/utils/DeviationMediaService';
import { ThemeOptions } from '@wix/da-react-context/pkg/constants';
import { BackgroundImageDisplayMode } from '@wix/da-shared-react/pkg/Background/types';
import { ProfileSkin, customSkin } from '../types/profileSkins';

type CustomSkinParams = {
  image?: PapiDeviation;
  imageDisplayMode?: BackgroundImageDisplayMode;
  theme?: ThemeOptions;
};
export const profileSkinFromProps = ({
  image,
  imageDisplayMode,
  theme,
}: CustomSkinParams = {}): ProfileSkin => {
  if (!image || !theme) {
    return {
      ...customSkin,
    };
  }
  const imageFile = MediaService.getLargestFullview(image);
  const imageThumb = MediaService.getSmallestThumbThatFullyCovers(
    image,
    150,
    95
  );
  const background = imageFile ? `url(${imageFile.src})` : '';
  const staticBackground = MediaService.isGif(image)
    ? customSkin.backgroundPreview
    : '';
  const backgroundPreview = imageThumb ? `url(${imageThumb?.src})` : 'none';
  const skin = {
    background,
    staticBackground,
    image,
    imageDisplayMode,
    baseTheme: theme,
  };

  return {
    ...customSkin,
    backgroundPreview,
    skin,
  };
};
